"use client";

import { useState } from "react";
import { useCart } from "@/components/CartProvider";
import { fixMaybeBrokenText } from "@/lib/text-client";

const DEFAULT_LABEL = "\u0412 \u043a\u043e\u0440\u0437\u0438\u043d\u0443";
const ADDED_LABEL = "\u0414\u043e\u0431\u0430\u0432\u043b\u0435\u043d\u043e";
const TOAST_TITLE = "\u0422\u043e\u0432\u0430\u0440 \u0434\u043e\u0431\u0430\u0432\u043b\u0435\u043d \u0432 \u043a\u043e\u0440\u0437\u0438\u043d\u0443";
const TOAST_CART_ACTION = "\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u043a\u043e\u0440\u0437\u0438\u043d\u0443";
const TOAST_OPEN_CART_ACTION = "\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u043a\u043e\u0440\u0437\u0438\u043d\u0443";

type AddToCartButtonProps = {
  item: {
    id: number;
    slug: string;
    sku: string | null;
    name: string;
    image: string;
    price: number;
    oldPrice: number;
    unit: string | null;
  };
  className?: string;
  label?: string;
  goToCartAfterAdd?: boolean;
};

export function AddToCartButton({
  item,
  className,
  label = DEFAULT_LABEL,
  goToCartAfterAdd = false
}: AddToCartButtonProps) {
  const { addItem } = useCart();
  const [isAdded, setIsAdded] = useState(false);

  return (
    <button
      className={className}
      onClick={() => {
        addItem(item, 1);
        setIsAdded(true);

        window.dispatchEvent(
          new CustomEvent("bitstone:toast", {
            detail: {
              title: TOAST_TITLE,
              message: fixMaybeBrokenText(item.name),
              actionHref: "/cart",
              actionLabel: goToCartAfterAdd ? TOAST_OPEN_CART_ACTION : TOAST_CART_ACTION
            }
          })
        );

        window.setTimeout(() => setIsAdded(false), 1500);
      }}
      type="button"
    >
      {isAdded ? ADDED_LABEL : fixMaybeBrokenText(label)}
    </button>
  );
}
